import React from 'react';

import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';

export interface RadioChipsProps {
  onChange: (value: string) => void;
  options: {
    label: string;
    value: string;
  }[];
  value: string;
}

export const RadioChips = ({ onChange, options, value }: RadioChipsProps) => {
  return (
    <RadioGroupPrimitive.Root
      className="flex gap-1"
      onValueChange={onChange}
      value={value}
    >
      {options.map((option) => (
        <RadioGroupPrimitive.Item
          className="bg-tg-section-bg data-[state=checked]:bg-tg-button data-[state=checked]:text-tg-button-text text-tg-hint typo-text rounded-3xl px-4 py-2"
          key={option.value}
          value={option.value}
        >
          {option.label}
        </RadioGroupPrimitive.Item>
      ))}
    </RadioGroupPrimitive.Root>
  );
};
